// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vendor_pageHeader__BQf25 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.Vendor_pageHeader__BQf25 h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.Vendor_pageHeader__BQf25 .Vendor_right__Gq6UW {
  display: flex;
  align-items: center;
  gap: 20px;
}
.Vendor_pageHeader__BQf25 .Vendor_right__Gq6UW .Vendor_date__dg7kh {
  display: flex;
  align-items: center;
  gap: 4px;
}
.Vendor_pageHeader__BQf25 .Vendor_right__Gq6UW .Vendor_date__dg7kh img,
.Vendor_pageHeader__BQf25 .Vendor_right__Gq6UW .Vendor_date__dg7kh svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.Vendor_pageHeader__BQf25 .Vendor_right__Gq6UW .Vendor_date__dg7kh span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

.Vendor_pageMain__UZJXr {
  padding: 0 24px;
}
.Vendor_pageMain__UZJXr .Vendor_pageScreen__y4FwA {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 16px 0;
}
@media screen and (max-width: 1420px) {
  .Vendor_pageMain__UZJXr .Vendor_pageScreen__y4FwA.Vendor_sidebarExpand__a7R1c {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 1040px) {
  .Vendor_pageMain__UZJXr .Vendor_pageScreen__y4FwA.Vendor_sidebarExpand__a7R1c {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media screen and (max-width: 768px) {
  .Vendor_pageMain__UZJXr .Vendor_pageScreen__y4FwA.Vendor_sidebarExpand__a7R1c {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media screen and (max-width: 1200px) {
  .Vendor_pageMain__UZJXr .Vendor_pageScreen__y4FwA {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 870px) {
  .Vendor_pageMain__UZJXr .Vendor_pageScreen__y4FwA {
    grid-template-columns: repeat(1, 1fr);
  }
}

.Vendor_mainTabs__x37sO .Vendor_detailsWrp__lHc3Q {
  margin-top: 16px;
}
.Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq {
  width: 100%;
  padding-bottom: 12px;
}
.Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq .Vendor_filterBtns__\\+-xRY {
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1 1;
  justify-content: flex-end;
}
.Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq .Vendor_filterBtns__\\+-xRY .Vendor_rightActions__qmCw0 {
  display: flex;
  align-items: center;
  gap: 12px;
}
.Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq .Vendor_filterBtns__\\+-xRY .Vendor_left__Q8LCK .Vendor_tabItem__EWmCw {
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
}
.Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq .Vendor_filterBtns__\\+-xRY .Vendor_left__Q8LCK .Vendor_tabItem__EWmCw.Vendor_selected__gx9fq img,
.Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq .Vendor_filterBtns__\\+-xRY .Vendor_left__Q8LCK .Vendor_tabItem__EWmCw.Vendor_selected__gx9fq svg {
  filter: grayscale(0);
}
.Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq .Vendor_filterBtns__\\+-xRY .Vendor_left__Q8LCK .Vendor_tabItem__EWmCw.Vendor_selected__gx9fq span {
  color: var(--brand);
}
.Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq .Vendor_filterBtns__\\+-xRY .Vendor_left__Q8LCK .Vendor_tabItem__EWmCw span {
  color: var(--secondary-Text);
  font: var(--body-font-three);
  font-weight: 500;
}
.Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq .Vendor_filterBtns__\\+-xRY .Vendor_left__Q8LCK .Vendor_tabItem__EWmCw img,
.Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq .Vendor_filterBtns__\\+-xRY .Vendor_left__Q8LCK .Vendor_tabItem__EWmCw svg {
  width: 16px;
  height: 16px;
  display: block;
  filter: grayscale(1);
}

.Vendor_cardView__pNpzT {
  background-color: var(--white);
  border-radius: 12px;
  border: 1px solid var(--border);
  overflow: hidden;
}
.Vendor_cardView__pNpzT .Vendor_cardHead__wICwz {
  background-color: var(--bg1);
  padding: 12px 0 12px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardHeadLeft__vaGwJ {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  max-width: calc(100% - 150px);
  overflow: hidden;
}
@media screen and (max-width: 450px) {
  .Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardHeadLeft__vaGwJ {
    flex-direction: column;
    align-items: start;
    width: 100%;
    max-width: 100%;
  }
}
.Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardHeadLeft__vaGwJ figure {
  display: flex;
}
.Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardHeadLeft__vaGwJ figure img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
  object-position: center;
  overflow: hidden;
  border: 1px solid var(--border);
}
.Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardResponse__hCqff {
  width: fit-content;
}
@media screen and (max-width: 450px) {
  .Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardResponse__hCqff {
    position: absolute;
    right: 0;
    top: 16px;
  }
}
.Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardHeadText__9Iqhs {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 100%;
}
@media screen and (max-width: 450px) {
  .Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardHeadText__9Iqhs {
    max-width: calc(100% - 12px);
  }
}
.Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardHeadText__9Iqhs h2 {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}
.Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardHeadText__9Iqhs .Vendor_cardHeadTextSub__37sJO {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}
.Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardHeadText__9Iqhs .Vendor_cardHeadTextSub__37sJO p {
  font: var(--body-font-four);
  font-weight: 400;
  color: var(--secondary-Text);
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding-left: 8px;
  border-left: 1px solid var(--border);
}
.Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardHeadText__9Iqhs .Vendor_cardHeadTextSub__37sJO p:first-child {
  padding-left: 0;
  border-left: 0;
}
.Vendor_cardView__pNpzT .Vendor_cardHead__wICwz .Vendor_cardHeadText__9Iqhs .Vendor_cardHeadTextSub__37sJO p img {
  width: 16px;
  height: 16px;
}
.Vendor_cardView__pNpzT .Vendor_cardBodyMain__U4KUS {
  background-color: var(--white);
  border-top: 1px solid var(--border);
  padding: 12px;
}
.Vendor_cardView__pNpzT .Vendor_cardBodyMain__U4KUS .Vendor_cardBody__umYXW p {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--brand);
}
.Vendor_cardView__pNpzT .Vendor_cardBodyMain__U4KUS .Vendor_cardBody__umYXW span {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--secondary-Text);
  display: block;
  margin-top: 4px;
}
.Vendor_cardView__pNpzT .Vendor_cardBodyMain__U4KUS .Vendor_cardFooter__MsNsj {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 450px) {
  .Vendor_cardView__pNpzT .Vendor_cardBodyMain__U4KUS .Vendor_cardFooter__MsNsj {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
}
.Vendor_cardView__pNpzT .Vendor_cardBodyMain__U4KUS .Vendor_cardFooter__MsNsj p {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
}
.Vendor_cardView__pNpzT .Vendor_cardBodyMain__U4KUS .Vendor_cardFooter__MsNsj .Vendor_cardFooterBtn__XeCBW {
  display: flex;
  gap: 12px;
}
.Vendor_cardView__pNpzT .Vendor_cardBodyMain__U4KUS .Vendor_cardFooter__MsNsj .Vendor_cardFooterBtn__XeCBW img {
  filter: brightness(0) invert(1);
}
@media screen and (max-width: 450px) {
  .Vendor_cardView__pNpzT .Vendor_cardBodyMain__U4KUS .Vendor_cardFooter__MsNsj .Vendor_cardFooterBtn__XeCBW {
    width: 100%;
  }
  .Vendor_cardView__pNpzT .Vendor_cardBodyMain__U4KUS .Vendor_cardFooter__MsNsj .Vendor_cardFooterBtn__XeCBW button {
    width: 100%;
  }
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N {
  padding: 8px;
  border-radius: 8px;
  background-color: var(--bg3);
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_submitted__qanQQ, .Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_pending__wrtHA {
  background-color: var(--bg3);
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_submitted__qanQQ p, .Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_pending__wrtHA p {
  color: var(--brand);
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_submitted__qanQQ p:before, .Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_pending__wrtHA p:before {
  background-color: var(--brand);
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_in-review__ezT87, .Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_in-progress__eTFGm {
  background-color: #fff5e9;
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_in-review__ezT87 p, .Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_in-progress__eTFGm p {
  color: var(--warning);
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_in-review__ezT87 p:before, .Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_in-progress__eTFGm p:before {
  background-color: var(--warning);
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_approved__yocrU, .Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_completed__mjz43 {
  background-color: #edf7ee;
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_approved__yocrU p, .Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_completed__mjz43 p {
  color: var(--success);
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_approved__yocrU p:before, .Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_completed__mjz43 p:before {
  background-color: var(--success);
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_declined__of2rp {
  background-color: #feeceb;
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_declined__of2rp p {
  color: var(--error);
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N.Vendor_declined__of2rp p:before {
  background-color: var(--error);
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N p {
  font: var(--body-font-four);
  font-weight: 500;
  color: var(--brand);
  position: relative;
  padding-left: 8px;
  text-align: center;
  width: fit-content;
  margin: 0 auto;
  text-transform: capitalize;
}
.Vendor_cardView__pNpzT .Vendor_cardStatus__Akg1N p:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: var(--brand);
}

.Vendor_formWrp__627yl {
  max-height: 550px;
  overflow-y: auto;
}
.Vendor_formWrp__627yl .Vendor_formField__62g-r .Vendor_label__9Cr0P {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}
.Vendor_formWrp__627yl .Vendor_prioritySelect__GPNG1 {
  display: flex;
  align-items: center;
  gap: 5px;
  font: var(--body-font-four);
  font-weight: 500;
  text-transform: capitalize;
  color: var(--primary-Text);
}
.Vendor_formWrp__627yl .Vendor_prioritySelect__GPNG1 img,
.Vendor_formWrp__627yl .Vendor_prioritySelect__GPNG1 svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.Vendor_formWrp__627yl .Vendor_fileUploadedList__9kvOz {
  padding: 12px;
  width: 100%;
  justify-content: flex-start;
}
.Vendor_formWrp__627yl .Vendor_fileUploadedList__9kvOz span {
  color: var(--brand);
  flex: 1 1;
}

.Vendor_titleInput__E-xmj {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-weight: 700;
  font-size: var(--h6);
  color: #000;
  text-transform: capitalize;
  margin: 0;
  padding: 5px 0;
}
.Vendor_titleInput__E-xmj::placeholder {
  color: var(--secondary-Text);
}

.Vendor_details__1disZ {
  padding: 12px 24px;
}
.Vendor_details__1disZ .Vendor_header__MuFbn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.Vendor_details__1disZ .Vendor_back__mE5Ep {
  background-color: transparent;
  padding: 10px 0;
  border: none;
  cursor: pointer;
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
  display: flex;
  align-items: center;
  gap: 8px;
}
.Vendor_details__1disZ .Vendor_back__mE5Ep img {
  width: 20px;
  height: 20px;
}
.Vendor_details__1disZ .Vendor_content__BVt4X {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 22px;
}
@media (max-width: 600px) {
  .Vendor_details__1disZ .Vendor_content__BVt4X {
    flex-direction: column;
    align-items: start;
  }
}
.Vendor_details__1disZ .Vendor_content__BVt4X .Vendor_headingGroup__l-Bo3 {
  width: fit-content;
}
.Vendor_details__1disZ .Vendor_content__BVt4X .Vendor_headingGroup__l-Bo3 h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.Vendor_details__1disZ .Vendor_content__BVt4X .Vendor_headingGroup__l-Bo3 p {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--secondary-Text);
  margin-top: 8px;
}
.Vendor_details__1disZ .Vendor_content__BVt4X .Vendor_btnsGroup__0mHOd {
  display: flex;
  gap: 12px;
}
@media (max-width: 600px) {
  .Vendor_details__1disZ .Vendor_content__BVt4X .Vendor_btnsGroup__0mHOd {
    flex-wrap: wrap;
  }
}
.Vendor_details__1disZ .Vendor_paymentLising__OzvAS {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 20px;
  margin-top: 24px;
}
@media (max-width: 768px) {
  .Vendor_details__1disZ .Vendor_paymentLising__OzvAS {
    flex-wrap: wrap;
  }
}
.Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentSummary__isPtT {
  width: 100%;
  background: var(--white);
  border-radius: 12px;
  border: 1px solid var(--border);
  padding: 16px;
}
@media (max-width: 1100px) {
  .Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentSummary__isPtT {
    width: 50%;
  }
}
@media (max-width: 768px) {
  .Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentSummary__isPtT {
    width: 100%;
  }
}
.Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentSummary__isPtT h2 {
  font: var(--body-font-one);
  font-weight: 600;
  color: var(--primary-Text);
  padding-bottom: 16px;
}
.Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentSummary__isPtT .Vendor_paymentSummaryList__4xlFI {
  border-top: 1px solid var(--border);
  padding-top: 16px;
}
.Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentSummary__isPtT .Vendor_paymentSummaryList__4xlFI ul {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
}
.Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentSummary__isPtT .Vendor_paymentSummaryList__4xlFI ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentSummary__isPtT .Vendor_paymentSummaryList__4xlFI ul li span.Vendor_label__9Cr0P {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--primary-Text);
}
.Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentSummary__isPtT .Vendor_paymentSummaryList__4xlFI ul li span.Vendor_value__j-jv9 {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
}
.Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentPaymentActivity__VIWsQ {
  max-width: 100%;
  min-width: 381px;
  background: var(--white);
  border-radius: 12px;
  border: 1px solid var(--border);
  padding: 16px;
}
@media (max-width: 1100px) {
  .Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentPaymentActivity__VIWsQ {
    width: 50%;
    max-width: 50%;
    min-width: auto;
  }
}
@media (max-width: 768px) {
  .Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentPaymentActivity__VIWsQ {
    width: 100%;
    max-width: 100%;
  }
}
.Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentPaymentActivity__VIWsQ h2 {
  font: var(--body-font-one);
  font-weight: 600;
  color: var(--primary-Text);
  padding-bottom: 16px;
}
.Vendor_details__1disZ .Vendor_paymentLising__OzvAS .Vendor_paymentPaymentActivity__VIWsQ .Vendor_paymentPaymentActivityList__U1thp {
  border-top: 1px solid var(--border);
  padding-top: 16px;
}

.Vendor_lineItemWrp__2Fhn3 {
  margin-top: 10px;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_header__MuFbn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_header__MuFbn h3 {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_row__cm89f {
  display: flex;
  align-items: center;
  gap: 16px;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridHeader__eGRFO {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 60px 60px;
  gap: 12px;
  align-items: center;
  padding: 0 0 8px 0;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridHeader__eGRFO .Vendor_headerCell__3FTsv {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
  text-align: left;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridHeader__eGRFO .Vendor_headerCell__3FTsv:nth-child(4) {
  text-align: right;
  padding-right: 12px;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridBody__h6sSl {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridBody__h6sSl .Vendor_gridRow__Ui1oC {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 60px 60px;
  gap: 12px;
  align-items: center;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridBody__h6sSl .Vendor_gridRow__Ui1oC .Vendor_gridCell__pdhKt {
  display: flex;
  align-items: center;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridBody__h6sSl .Vendor_gridRow__Ui1oC .Vendor_gridCell__pdhKt:last-child {
  justify-content: center;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridBody__h6sSl .Vendor_gridRow__Ui1oC .Vendor_gridCell__pdhKt .Vendor_amountDisplay__rdrmd {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
  text-align: left;
  width: 100%;
  padding-right: 12px;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridBody__h6sSl .Vendor_gridRow__Ui1oC .Vendor_gridCell__pdhKt button {
  min-width: auto;
  padding: 8px;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridBody__h6sSl .Vendor_gridRow__Ui1oC .Vendor_gridCell__pdhKt button img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridFooter__taxFA {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 24px 0 0 0;
  padding: 12px 0;
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridFooter__taxFA .Vendor_summaryRow__POkFw {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 40px;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridFooter__taxFA .Vendor_summaryRow__POkFw .Vendor_summaryLabel__bJ6F- {
  font: var(--body-font-two);
  font-weight: 400;
  color: var(--primary-Text);
  min-width: 100px;
  text-align: right;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridFooter__taxFA .Vendor_summaryRow__POkFw .Vendor_summaryValue__L1oyj {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
  min-width: 80px;
  text-align: right;
}
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridFooter__taxFA .Vendor_summaryRow__POkFw:last-child .Vendor_summaryLabel__bJ6F-,
.Vendor_lineItemWrp__2Fhn3 .Vendor_lineItemGrid__sc-rO .Vendor_gridFooter__taxFA .Vendor_summaryRow__POkFw:last-child .Vendor_summaryValue__L1oyj {
  font-weight: 700;
}

.Vendor_templateTaxTab__ZQTH9 {
  max-height: 500px;
  overflow-y: auto;
}
.Vendor_templateTaxTab__ZQTH9 .Vendor_formField__62g-r .Vendor_label__9Cr0P {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}
.Vendor_templateTaxTab__ZQTH9 .Vendor_title__CMDOH {
  margin-bottom: 5px;
}
.Vendor_templateTaxTab__ZQTH9 .Vendor_title__CMDOH h6 {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
}
.Vendor_templateTaxTab__ZQTH9 .Vendor_title__CMDOH h6 span {
  font-weight: 400;
}

.Vendor_footerContent__rxWXk {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 16px 0 0 0;
}
@media (max-width: 599px) {
  .Vendor_footerContent__rxWXk {
    flex-direction: column;
  }
  .Vendor_footerContent__rxWXk button {
    width: 100%;
  }
}

@media (max-width: 599px) {
  .Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq .Vendor_filterBtns__\\+-xRY .Vendor_rightActions__qmCw0 {
    width: 100%;
  }
  .Vendor_mainTabs__x37sO .Vendor_topRow__\\+xaUq .Vendor_filterBtns__\\+-xRY .Vendor_rightActions__qmCw0 button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/payments/Vendor/index.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AACD;AACC;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AACF;AAEC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAAJ;AAGG;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AADJ;;AAOA;EACC,eAAA;AAJD;AAMC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,eAAA;AAJF;AAOG;EADD;IAEE,qCAAA;EAJF;AACF;AAMG;EALD;IAME,qCAAA;EAHF;AACF;AAKG;EATD;IAUE,qCAAA;EAFF;AACF;AAKE;EApBD;IAqBE,qCAAA;EAFD;AACF;AAIE;EAxBD;IAyBE,qCAAA;EADD;AACF;;AAMC;EACC,gBAAA;AAHF;AAMC;EACC,WAAA;EACA,oBAAA;AAJF;AAME;EACC,aAAA;EAEA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AALH;AAOG;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AALJ;AASI;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAPL;AAWM;;EAEC,oBAAA;AATP;AAYM;EACC,mBAAA;AAVP;AAcK;EACC,4BAAA;EACA,4BAAA;EACA,gBAAA;AAZN;AAeK;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AAbN;;AAqBA;EACC,8BAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;AAlBD;AAoBC;EACC,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAlBF;AAyBE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AAvBH;AAyBG;EARD;IASE,sBAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;EAtBF;AACF;AAwBG;EACC,aAAA;AAtBJ;AAwBI;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,+BAAA;AAtBL;AA2BE;EACC,kBAAA;AAzBH;AA2BG;EAHD;IAKE,kBAAA;IACA,QAAA;IACA,SAAA;EAzBF;AACF;AA4BE;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AA1BH;AA4BG;EAND;IAOE,4BAAA;EAzBF;AACF;AA2BG;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;EAEA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA1BJ;AA6BG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA3BJ;AA6BI;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EACA,oCAAA;AA5BL;AA8BK;EACC,eAAA;EACA,cAAA;AA5BN;AA+BK;EACC,WAAA;EACA,YAAA;AA7BN;AAoCC;EACC,8BAAA;EACA,mCAAA;EACA,aAAA;AAlCF;AAqCG;EACC,4BAAA;EACA,gBAAA;EACA,mBAAA;AAnCJ;AAsCG;EACC,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;AApCJ;AAwCE;EACC,gBAAA;EACA,iBAAA;EACA,mCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAtCH;AAwCG;EARD;IASE,sBAAA;IACA,SAAA;IACA,kBAAA;EArCF;AACF;AAuCG;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AArCJ;AAwCG;EACC,aAAA;EACA,SAAA;AAtCJ;AAwCI;EACC,+BAAA;AAtCL;AAyCI;EARD;IASE,WAAA;EAtCH;EAwCG;IACC,WAAA;EAtCJ;AACF;AA4CC;EACC,YAAA;EACA,kBAAA;EACA,4BAAA;AA1CF;AA4CE;EAEC,4BAAA;AA3CH;AA6CG;EACC,mBAAA;AA3CJ;AA6CI;EACC,8BAAA;AA3CL;AAgDE;EAEC,yBAAA;AA/CH;AAiDG;EACC,qBAAA;AA/CJ;AAiDI;EACC,gCAAA;AA/CL;AAoDE;EAEC,yBAAA;AAnDH;AAqDG;EACC,qBAAA;AAnDJ;AAqDI;EACC,gCAAA;AAnDL;AAwDE;EACC,yBAAA;AAtDH;AAwDG;EACC,mBAAA;AAtDJ;AAwDI;EACC,8BAAA;AAtDL;AA2DE;EACC,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;AAzDH;AA2DG;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;AAzDJ;;AA+DA;EACC,iBAAA;EACA,gBAAA;AA5DD;AA+DE;EACC,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AA7DH;AAiEC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;AA/DF;AAiEE;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AA/DH;AAmEC;EACC,aAAA;EACA,WAAA;EACA,2BAAA;AAjEF;AAmEE;EACC,mBAAA;EACA,SAAA;AAjEH;;AAsEA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,0BAAA;EACA,SAAA;EACA,cAAA;AAnED;AAqEC;EACC,4BAAA;AAnEF;;AAuEA;EACC,kBAAA;AApED;AAsEC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AApEF;AAuEC;EACC,6BAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AArEF;AAuEE;EACC,WAAA;EACA,YAAA;AArEH;AAyEC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAvEF;AAyEE;EAPD;IAQE,sBAAA;IACA,kBAAA;EAtED;AACF;AAwEE;EACC,kBAAA;AAtEH;AAwEG;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAtEJ;AAyEG;EACC,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;AAvEJ;AA2EE;EACC,aAAA;EACA,SAAA;AAzEH;AA2EG;EAJD;IAKE,eAAA;EAxEF;AACF;AA4EC;EACC,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;AA1EF;AA4EE;EAPD;IAQE,eAAA;EAzED;AACF;AA2EE;EACC,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,+BAAA;EACA,aAAA;AAzEH;AA2EG;EAPD;IAQE,UAAA;EAxEF;AACF;AA0EG;EAXD;IAYE,WAAA;EAvEF;AACF;AAyEG;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,oBAAA;AAvEJ;AA0EG;EACC,mCAAA;EACA,iBAAA;AAxEJ;AA0EI;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;AAxEL;AA0EK;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAxEN;AA0EM;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AAxEP;AA2EM;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AAzEP;AAgFE;EACC,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,+BAAA;EACA,aAAA;AA9EH;AAgFG;EARD;IASE,UAAA;IACA,cAAA;IACA,eAAA;EA7EF;AACF;AA+EG;EAdD;IAeE,WAAA;IACA,eAAA;EA5EF;AACF;AA8EG;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,oBAAA;AA5EJ;AA+EG;EACC,mCAAA;EACA,iBAAA;AA7EJ;;AAmFA;EACC,gBAAA;AAhFD;AAkFC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAhFF;AAkFE;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;AAhFH;AAoFC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAlFF;AAqFC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAnFF;AAqFE;EACC,aAAA;EACA,4CAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAnFH;AAqFG;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AAnFJ;AAqFI;EACC,iBAAA;EACA,mBAAA;AAnFL;AAwFE;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAtFH;AAwFG;EACC,aAAA;EACA,4CAAA;EACA,SAAA;EACA,mBAAA;AAtFJ;AAwFI;EACC,aAAA;EACA,mBAAA;AAtFL;AAwFK;EACC,uBAAA;AAtFN;AAyFK;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAvFN;AA0FK;EACC,eAAA;EACA,YAAA;AAxFN;AA0FM;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AAxFP;AA+FE;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;EACA,sCAAA;AA7FH;AA+FG;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AA7FJ;AA+FI;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;AA7FL;AAgGI;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;AA9FL;AAmGK;;EAEC,gBAAA;AAjGN;;AAyGA;EACC,iBAAA;EACA,gBAAA;AAtGD;AAyGE;EACC,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AAvGH;AA2GC;EACC,kBAAA;AAzGF;AA2GE;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;AAzGH;AA2GG;EACC,gBAAA;AAzGJ;;AA+GA;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA5GD;AA8GC;EAPD;IAQE,sBAAA;EA3GA;EA6GA;IACC,WAAA;EA3GD;AACF;;AA+GA;EAOI;IACC,WAAA;EAlHH;EAoHG;IACC,WAAA;EAlHJ;AACF","sourcesContent":[".pageHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 16px 24px;\r\n\tborder-bottom: 1px solid var(--border);\r\n\tmargin-bottom: 16px;\r\n\r\n\th1 {\r\n\t\tfont: var(--h3);\r\n\t\tfont-weight: 700;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tfont-family: var(--font-bodoni-72);\r\n\t}\r\n\r\n\t.right {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 20px;\r\n\r\n\t\t.date {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 4px;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.pageMain {\r\n\tpadding: 0 24px;\r\n\r\n\t.pageScreen {\r\n\t\tdisplay: grid;\r\n\t\tgrid-template-columns: repeat(3, 1fr);\r\n\t\tgap: 20px;\r\n\t\tpadding: 16px 0;\r\n\r\n\t\t&.sidebarExpand {\r\n\t\t\t@media screen and (max-width: 1420px) {\r\n\t\t\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\t\t}\r\n\r\n\t\t\t@media screen and (max-width: 1040px) {\r\n\t\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\t}\r\n\r\n\t\t\t@media screen and (max-width: 768px) {\r\n\t\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t@media screen and (max-width: 1200px) {\r\n\t\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\t}\r\n\r\n\t\t@media screen and (max-width: 870px) {\r\n\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.mainTabs {\r\n\t.detailsWrp {\r\n\t\tmargin-top: 16px;\r\n\t}\r\n\r\n\t.topRow {\r\n\t\twidth: 100%;\r\n\t\tpadding-bottom: 12px;\r\n\r\n\t\t.filterBtns {\r\n\t\t\tdisplay: flex;\r\n\t\t\t// flex-wrap: wrap;\r\n\t\t\tgap: 12px;\r\n\t\t\talign-items: center;\r\n\t\t\tflex: 1;\r\n\t\t\tjustify-content: flex-end;\r\n\r\n\t\t\t.rightActions {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t}\r\n\r\n\t\t\t.left {\r\n\t\t\t\t.tabItem {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 8px;\r\n\t\t\t\t\ttext-align: left;\r\n\r\n\t\t\t\t\t&.selected {\r\n\r\n\t\t\t\t\t\timg,\r\n\t\t\t\t\t\tsvg {\r\n\t\t\t\t\t\t\tfilter: grayscale(0);\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\tspan {\r\n\t\t\t\t\t\t\tcolor: var(--brand);\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\timg,\r\n\t\t\t\t\tsvg {\r\n\t\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\t\theight: 16px;\r\n\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t\tfilter: grayscale(1);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.cardView {\r\n\tbackground-color: var(--white);\r\n\tborder-radius: 12px;\r\n\tborder: 1px solid var(--border);\r\n\toverflow: hidden;\r\n\r\n\t.cardHead {\r\n\t\tbackground-color: var(--bg1);\r\n\t\tpadding: 12px 0 12px 12px;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tposition: relative;\r\n\r\n\t\t@media screen and (max-width: 450px) {\r\n\t\t\t// flex-direction: column;\r\n\t\t\t// gap: 16px;\r\n\t\t}\r\n\r\n\t\t.cardHeadLeft {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t\twidth: fit-content;\r\n\t\t\tmax-width: calc(100% - 150px);\r\n\t\t\toverflow: hidden;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\talign-items: start;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t}\r\n\r\n\t\t\tfigure {\r\n\t\t\t\tdisplay: flex;\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 48px;\r\n\t\t\t\t\theight: 48px;\r\n\t\t\t\t\tobject-fit: cover;\r\n\t\t\t\t\tborder-radius: 50%;\r\n\t\t\t\t\tobject-position: center;\r\n\t\t\t\t\toverflow: hidden;\r\n\t\t\t\t\tborder: 1px solid var(--border);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cardResponse {\r\n\t\t\twidth: fit-content;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\t// width: 100%;\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tright: 0;\r\n\t\t\t\ttop: 16px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cardHeadText {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 4px;\r\n\t\t\tmax-width: 100%;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tmax-width: calc(100% - 12px);\r\n\t\t\t}\r\n\r\n\t\t\th2 {\r\n\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\r\n\t\t\t\ttext-overflow: ellipsis;\r\n\t\t\t\toverflow: hidden;\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t\twhite-space: nowrap;\r\n\t\t\t}\r\n\r\n\t\t\t.cardHeadTextSub {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: start;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 8px;\r\n\t\t\t\tmargin-top: 4px;\r\n\r\n\t\t\t\tp {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 4px;\r\n\t\t\t\t\tmargin: 0;\r\n\r\n\t\t\t\t\tpadding-left: 8px;\r\n\t\t\t\t\tborder-left: 1px solid var(--border);\r\n\r\n\t\t\t\t\t&:first-child {\r\n\t\t\t\t\t\tpadding-left: 0;\r\n\t\t\t\t\t\tborder-left: 0;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\timg {\r\n\t\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\t\theight: 16px;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.cardBodyMain {\r\n\t\tbackground-color: var(--white);\r\n\t\tborder-top: 1px solid var(--border);\r\n\t\tpadding: 12px;\r\n\r\n\t\t.cardBody {\r\n\t\t\tp {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 500;\r\n\t\t\t\tcolor: var(--brand);\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tmargin-top: 4px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cardFooter {\r\n\t\t\tmargin-top: 16px;\r\n\t\t\tpadding-top: 16px;\r\n\t\t\tborder-top: 1px solid var(--border);\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\tgap: 16px;\r\n\t\t\t\talign-items: start;\r\n\t\t\t}\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t}\r\n\r\n\t\t\t.cardFooterBtn {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tgap: 12px;\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\tfilter: brightness(0) invert(1);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.cardStatus {\r\n\t\tpadding: 8px;\r\n\t\tborder-radius: 8px;\r\n\t\tbackground-color: var(--bg3);\r\n\r\n\t\t&.submitted,\r\n\t\t&.pending {\r\n\t\t\tbackground-color: var(--bg3);\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--brand);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--brand);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.in-review,\r\n\t\t&.in-progress {\r\n\t\t\tbackground-color: #fff5e9;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--warning);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--warning);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.approved,\r\n\t\t&.completed {\r\n\t\t\tbackground-color: #edf7ee;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--success);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--success);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.declined {\r\n\t\t\tbackground-color: #feeceb;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--error);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--error);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\tp {\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tposition: relative;\r\n\t\t\tpadding-left: 8px;\r\n\t\t\ttext-align: center;\r\n\t\t\twidth: fit-content;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\ttext-transform: capitalize;\r\n\r\n\t\t\t&:before {\r\n\t\t\t\tcontent: '';\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\ttop: 50%;\r\n\t\t\t\tleft: 0;\r\n\t\t\t\ttransform: translateY(-50%);\r\n\t\t\t\twidth: 4px;\r\n\t\t\t\theight: 4px;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t\tbackground-color: var(--brand);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.formWrp {\r\n\tmax-height: 550px;\r\n\toverflow-y: auto;\r\n\r\n\t.formField {\r\n\t\t.label {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tdisplay: block;\r\n\t\t\tmargin-bottom: 4px;\r\n\t\t}\r\n\t}\r\n\r\n\t.prioritySelect {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 5px;\r\n\t\tfont: var(--body-font-four);\r\n\t\tfont-weight: 500;\r\n\t\ttext-transform: capitalize;\r\n\t\tcolor: var(--primary-Text);\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\twidth: 16px;\r\n\t\t\theight: 16px;\r\n\t\t\tobject-fit: scale-down;\r\n\t\t\tdisplay: block;\r\n\t\t}\r\n\t}\r\n\r\n\t.fileUploadedList {\r\n\t\tpadding: 12px;\r\n\t\twidth: 100%;\r\n\t\tjustify-content: flex-start;\r\n\r\n\t\tspan {\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tflex: 1;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.titleInput {\r\n\twidth: 100%;\r\n\tborder: none;\r\n\toutline: none;\r\n\tbackground: transparent;\r\n\tfont-weight: 700;\r\n\tfont-size: var(--h6);\r\n\tcolor: #000;\r\n\ttext-transform: capitalize;\r\n\tmargin: 0;\r\n\tpadding: 5px 0;\r\n\r\n\t&::placeholder {\r\n\t\tcolor: var(--secondary-Text);\r\n\t}\r\n}\r\n\r\n.details {\r\n\tpadding: 12px 24px;\r\n\r\n\t.header {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 16px;\r\n\t}\r\n\r\n\t.back {\r\n\t\tbackground-color: transparent;\r\n\t\tpadding: 10px 0;\r\n\t\tborder: none;\r\n\t\tcursor: pointer;\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 500;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 8px;\r\n\r\n\t\timg {\r\n\t\t\twidth: 20px;\r\n\t\t\theight: 20px;\r\n\t\t}\r\n\t}\r\n\r\n\t.content {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 16px;\r\n\t\tmargin-top: 22px;\r\n\r\n\t\t@media (max-width: 600px) {\r\n\t\t\tflex-direction: column;\r\n\t\t\talign-items: start;\r\n\t\t}\r\n\r\n\t\t.headingGroup {\r\n\t\t\twidth: fit-content;\r\n\r\n\t\t\th1 {\r\n\t\t\t\tfont: var(--h3);\r\n\t\t\t\tfont-weight: 700;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t\t}\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tmargin-top: 8px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.btnsGroup {\r\n\t\t\tdisplay: flex;\r\n\t\t\tgap: 12px;\r\n\r\n\t\t\t@media (max-width: 600px) {\r\n\t\t\t\tflex-wrap: wrap;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.paymentLising {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: stretch;\r\n\t\tgap: 20px;\r\n\t\tmargin-top: 24px;\r\n\r\n\t\t@media (max-width: 768px) {\r\n\t\t\tflex-wrap: wrap;\r\n\t\t}\r\n\r\n\t\t.paymentSummary {\r\n\t\t\twidth: 100%;\r\n\t\t\tbackground: var(--white);\r\n\t\t\tborder-radius: 12px;\r\n\t\t\tborder: 1px solid var(--border);\r\n\t\t\tpadding: 16px;\r\n\r\n\t\t\t@media (max-width: 1100px) {\r\n\t\t\t\twidth: 50%;\r\n\t\t\t}\r\n\r\n\t\t\t@media (max-width: 768px) {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\r\n\t\t\th2 {\r\n\t\t\t\tfont: var(--body-font-one);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tpadding-bottom: 16px;\r\n\t\t\t}\r\n\r\n\t\t\t.paymentSummaryList {\r\n\t\t\t\tborder-top: 1px solid var(--border);\r\n\t\t\t\tpadding-top: 16px;\r\n\r\n\t\t\t\tul {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\tflex-direction: column;\r\n\t\t\t\t\tjustify-content: space-between;\r\n\t\t\t\t\tgap: 16px;\r\n\r\n\t\t\t\t\tli {\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\tjustify-content: space-between;\r\n\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\tgap: 16px;\r\n\r\n\t\t\t\t\t\tspan.label {\r\n\t\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\tspan.value {\r\n\t\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.paymentPaymentActivity {\r\n\t\t\tmax-width: 100%;\r\n\t\t\tmin-width: 381px;\r\n\t\t\tbackground: var(--white);\r\n\t\t\tborder-radius: 12px;\r\n\t\t\tborder: 1px solid var(--border);\r\n\t\t\tpadding: 16px;\r\n\r\n\t\t\t@media (max-width: 1100px) {\r\n\t\t\t\twidth: 50%;\r\n\t\t\t\tmax-width: 50%;\r\n\t\t\t\tmin-width: auto;\r\n\t\t\t}\r\n\r\n\t\t\t@media (max-width: 768px) {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t}\r\n\r\n\t\t\th2 {\r\n\t\t\t\tfont: var(--body-font-one);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tpadding-bottom: 16px;\r\n\t\t\t}\r\n\r\n\t\t\t.paymentPaymentActivityList {\r\n\t\t\t\tborder-top: 1px solid var(--border);\r\n\t\t\t\tpadding-top: 16px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.lineItemWrp {\r\n\tmargin-top: 10px;\r\n\r\n\t.header {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 16px;\r\n\t\tmargin-bottom: 12px;\r\n\r\n\t\th3 {\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\t}\r\n\r\n\t.row {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 16px;\r\n\t}\r\n\r\n\t.lineItemGrid {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 12px;\r\n\r\n\t\t.gridHeader {\r\n\t\t\tdisplay: grid;\r\n\t\t\tgrid-template-columns: 2fr 1fr 1fr 60px 60px;\r\n\t\t\tgap: 12px;\r\n\t\t\talign-items: center;\r\n\t\t\tpadding: 0 0 8px 0;\r\n\r\n\t\t\t.headerCell {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\ttext-align: left;\r\n\r\n\t\t\t\t&:nth-child(4) {\r\n\t\t\t\t\ttext-align: right;\r\n\t\t\t\t\tpadding-right: 12px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.gridBody {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 12px;\r\n\r\n\t\t\t.gridRow {\r\n\t\t\t\tdisplay: grid;\r\n\t\t\t\tgrid-template-columns: 2fr 1fr 1fr 60px 60px;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t\talign-items: center;\r\n\r\n\t\t\t\t.gridCell {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\r\n\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\tjustify-content: center;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t.amountDisplay {\r\n\t\t\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\t\ttext-align: left;\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\tpadding-right: 12px;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\tmin-width: auto;\r\n\t\t\t\t\t\tpadding: 8px;\r\n\r\n\t\t\t\t\t\timg {\r\n\t\t\t\t\t\t\twidth: 20px;\r\n\t\t\t\t\t\t\theight: 20px;\r\n\t\t\t\t\t\t\tobject-fit: contain;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.gridFooter {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 12px;\r\n\t\t\tmargin: 24px 0 0 0;\r\n\t\t\tpadding: 12px 0;\r\n\t\t\tborder-top: 1px solid var(--border);\r\n\t\t\tborder-bottom: 1px solid var(--border);\r\n\r\n\t\t\t.summaryRow {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: flex-end;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 40px;\r\n\r\n\t\t\t\t.summaryLabel {\r\n\t\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tmin-width: 100px;\r\n\t\t\t\t\ttext-align: right;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.summaryValue {\r\n\t\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tmin-width: 80px;\r\n\t\t\t\t\ttext-align: right;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:last-child {\r\n\r\n\t\t\t\t\t.summaryLabel,\r\n\t\t\t\t\t.summaryValue {\r\n\t\t\t\t\t\tfont-weight: 700;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.templateTaxTab {\r\n\tmax-height: 500px;\r\n\toverflow-y: auto;\r\n\r\n\t.formField {\r\n\t\t.label {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tdisplay: block;\r\n\t\t\tmargin-bottom: 4px;\r\n\t\t}\r\n\t}\r\n\r\n\t.title {\r\n\t\tmargin-bottom: 5px;\r\n\r\n\t\th6 {\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: var(--primary-Text);\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.footerContent {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-end;\r\n\talign-items: center;\r\n\tgap: 12px;\r\n\tpadding: 16px 0 0 0;\r\n\r\n\t@media (max-width: 599px) {\r\n\t\tflex-direction: column;\r\n\r\n\t\tbutton {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 599px) {\r\n\t.mainTabs {\r\n\t\t.topRow {\r\n\t\t\t.filterBtns {\r\n\r\n\t\t\t\t// flex-direction: column;\r\n\t\t\t\t// align-items: flex-start;\r\n\t\t\t\t.rightActions {\r\n\t\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `Vendor_pageHeader__BQf25`,
	"right": `Vendor_right__Gq6UW`,
	"date": `Vendor_date__dg7kh`,
	"pageMain": `Vendor_pageMain__UZJXr`,
	"pageScreen": `Vendor_pageScreen__y4FwA`,
	"sidebarExpand": `Vendor_sidebarExpand__a7R1c`,
	"mainTabs": `Vendor_mainTabs__x37sO`,
	"detailsWrp": `Vendor_detailsWrp__lHc3Q`,
	"topRow": `Vendor_topRow__+xaUq`,
	"filterBtns": `Vendor_filterBtns__+-xRY`,
	"rightActions": `Vendor_rightActions__qmCw0`,
	"left": `Vendor_left__Q8LCK`,
	"tabItem": `Vendor_tabItem__EWmCw`,
	"selected": `Vendor_selected__gx9fq`,
	"cardView": `Vendor_cardView__pNpzT`,
	"cardHead": `Vendor_cardHead__wICwz`,
	"cardHeadLeft": `Vendor_cardHeadLeft__vaGwJ`,
	"cardResponse": `Vendor_cardResponse__hCqff`,
	"cardHeadText": `Vendor_cardHeadText__9Iqhs`,
	"cardHeadTextSub": `Vendor_cardHeadTextSub__37sJO`,
	"cardBodyMain": `Vendor_cardBodyMain__U4KUS`,
	"cardBody": `Vendor_cardBody__umYXW`,
	"cardFooter": `Vendor_cardFooter__MsNsj`,
	"cardFooterBtn": `Vendor_cardFooterBtn__XeCBW`,
	"cardStatus": `Vendor_cardStatus__Akg1N`,
	"submitted": `Vendor_submitted__qanQQ`,
	"pending": `Vendor_pending__wrtHA`,
	"in-review": `Vendor_in-review__ezT87`,
	"in-progress": `Vendor_in-progress__eTFGm`,
	"approved": `Vendor_approved__yocrU`,
	"completed": `Vendor_completed__mjz43`,
	"declined": `Vendor_declined__of2rp`,
	"formWrp": `Vendor_formWrp__627yl`,
	"formField": `Vendor_formField__62g-r`,
	"label": `Vendor_label__9Cr0P`,
	"prioritySelect": `Vendor_prioritySelect__GPNG1`,
	"fileUploadedList": `Vendor_fileUploadedList__9kvOz`,
	"titleInput": `Vendor_titleInput__E-xmj`,
	"details": `Vendor_details__1disZ`,
	"header": `Vendor_header__MuFbn`,
	"back": `Vendor_back__mE5Ep`,
	"content": `Vendor_content__BVt4X`,
	"headingGroup": `Vendor_headingGroup__l-Bo3`,
	"btnsGroup": `Vendor_btnsGroup__0mHOd`,
	"paymentLising": `Vendor_paymentLising__OzvAS`,
	"paymentSummary": `Vendor_paymentSummary__isPtT`,
	"paymentSummaryList": `Vendor_paymentSummaryList__4xlFI`,
	"value": `Vendor_value__j-jv9`,
	"paymentPaymentActivity": `Vendor_paymentPaymentActivity__VIWsQ`,
	"paymentPaymentActivityList": `Vendor_paymentPaymentActivityList__U1thp`,
	"lineItemWrp": `Vendor_lineItemWrp__2Fhn3`,
	"row": `Vendor_row__cm89f`,
	"lineItemGrid": `Vendor_lineItemGrid__sc-rO`,
	"gridHeader": `Vendor_gridHeader__eGRFO`,
	"headerCell": `Vendor_headerCell__3FTsv`,
	"gridBody": `Vendor_gridBody__h6sSl`,
	"gridRow": `Vendor_gridRow__Ui1oC`,
	"gridCell": `Vendor_gridCell__pdhKt`,
	"amountDisplay": `Vendor_amountDisplay__rdrmd`,
	"gridFooter": `Vendor_gridFooter__taxFA`,
	"summaryRow": `Vendor_summaryRow__POkFw`,
	"summaryLabel": `Vendor_summaryLabel__bJ6F-`,
	"summaryValue": `Vendor_summaryValue__L1oyj`,
	"templateTaxTab": `Vendor_templateTaxTab__ZQTH9`,
	"title": `Vendor_title__CMDOH`,
	"footerContent": `Vendor_footerContent__rxWXk`
};
export default ___CSS_LOADER_EXPORT___;
